
 if(window.innerWidth < 768) {
     if ($('.shop-by-subject .filter-value').length > 2) {
      $('.shop-by-subject .filter-value:gt(2)').hide();
      $('.shop-by-subject .show-more-values').show();
      }else{
         $('.shop-by-subject .show-more-values').hide(); 
      }
      $('.shop-by-subject .show-more-values').on('click', function() {
      //toggle elements with class .ty-compact-list that their index is bigger than 2
      $('.shop-by-subject .filter-value:gt(2)').toggle();
      //change text of show more element just for demonstration purposes to this demo
      $(this).text() === 'Show more' ? $(this).text('Show less') : $(this).text('Show more');
      });
 }else{
      if ($('.shop-by-subject .filter-value').length > 8) {
      $('.shop-by-subject .filter-value:gt(8)').hide();
      $('.shop-by-subject .show-more-values').show();
      }else{
         $('.shop-by-subject .show-more-values').hide(); 
      }
      $('.shop-by-subject .show-more-values').on('click', function() {
      //toggle elements with class .ty-compact-list that their index is bigger than 2
      $('.shop-by-subject .filter-value:gt(8)').toggle();
      //change text of show more element just for demonstration purposes to this demo
      $(this).text() === 'Show more' ? $(this).text('Show less') : $(this).text('Show more');
      });
 }
 if(window.innerWidth < 768) {
      if ($('.shop-by-occasion .filter-value').length > 2) {
      $('.shop-by-occasion .filter-value:gt(2)').hide();
      $('.shop-by-occasion .show-more-values').show();
    }else{
      $('.shop-by-occasion .show-more-values').hide(); 
    }
    
    $('.shop-by-occasion .show-more-values').on('click', function() {
    //toggle elements with class .ty-compact-list that their index is bigger than 2
    $('.shop-by-occasion .filter-value:gt(2)').toggle();
    //change text of show more element just for demonstration purposes to this demo
    $(this).text() === 'Show more' ? $(this).text('Show less') : $(this).text('Show more');
    }); 
 }else{
    if ($('.shop-by-occasion .filter-value').length > 8) {
      $('.shop-by-occasion .filter-value:gt(8)').hide();
      $('.shop-by-occasion .show-more-values').show();
    }else{
      $('.shop-by-occasion .show-more-values').hide(); 
    }
    
    $('.shop-by-occasion .show-more-values').on('click', function() {
    //toggle elements with class .ty-compact-list that their index is bigger than 2
    $('.shop-by-occasion .filter-value:gt(8)').toggle();
    //change text of show more element just for demonstration purposes to this demo
    $(this).text() === 'Show more' ? $(this).text('Show less') : $(this).text('Show more');
    }); 
 }




$(document).ready(function(){ 
     $('.variant-input input').prop("disabled", false);
    $('.variant-input input').click(function(){ 
   $('.variant-input input').prop("disabled", false);
  
  });
});